module.exports = __webpack_public_path__ + "img/mhp.6037599c.webp";